import { useEffect } from 'react';
import {
  isAuthSessionValid,
  clearAuthSession,
  getSessionExpiresAt,
} from '../utils/authSession';

function redirectToLogin(reason = 'expired') {
  clearAuthSession();
  const path = reason === 'expired' ? '/login?expired=1' : '/login';
  if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
    window.location.href = path;
  } else {
    window.location.reload();
  }
}

export default function useSessionGuard() {
  useEffect(() => {
    const checkSession = () => {
      const hasLoggedInFlag = localStorage.getItem('loggedIn') === 'true';
      if (hasLoggedInFlag && !isAuthSessionValid()) {
        redirectToLogin('expired');
      }
    };

    checkSession();

    const expiresAt = getSessionExpiresAt();
    let expiryTimer = null;
    if (expiresAt > Date.now()) {
      expiryTimer = setTimeout(() => redirectToLogin('expired'), expiresAt - Date.now());
    }

    const interval = setInterval(checkSession, 60 * 1000);

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        checkSession();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      clearInterval(interval);
      if (expiryTimer) clearTimeout(expiryTimer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
}
